export const ru = {
    'error-message': 'Не удалось выполнить запрос, попробуйте позже.',
    'freelancer-page-header': 'Специалист по Яндекс.Директу',
    'withdraw-coop-success':
        'Вы отозвали запрос к специалисту. Вы можете выбрать другого специалиста для сотрудничества или снова отправить запрос этому контакту.'
};
